import React from "react";

export const LazyProjectInfoPage = React.lazy(
  () => import("modules/projectRole/pages/ProjectInfoPage"),
);
